





















import Vue from 'vue'

import CTA from '@/component/common/CTA.vue'

export default Vue.extend({
  name: 'Application',
  components: {
    CTA
  }
})
